/**
 * 행사별 설정 상수
 * 환경별(dev/prod) event_idx가 다르므로 env 변수로 관리
 */

// 1차 신청 수정 잠금 행사 (신청·1차수정 불가, 액티비티 수정·양도만 가능)
export const LOCKED_EVENT_IDX = Number(process.env.REACT_APP_LOCKED_EVENT_IDX);
